<template>
  <div v-for="(item,index) in userRemarkList" :key="index" style="margin: 8px 0; font-size: 14px; display: flex; flex-wrap: wrap;">
    <p><span style="margin-right: 8px;">{{ item.visitTime }}</span><el-tag size="small" v-if="item.visitAdminName">{{item.visitAdminName}}</el-tag></p>
    <p>回访项目：{{ item.name }}</p>
    <p>回访满意度：{{ item.satisfaction == 1?'不满意':item.satisfaction == 2?'一般':item.satisfaction == 3?'满意':item.satisfaction == 4?'未回复':'' }}</p>
    <p>问题反馈：{{ item.problem }}</p>
  </div>
</template>

<script>
export default {
name: "UserLog",
  props: {
    userRemarkList: {
      type: Array,
      default: [],
    }
  }
}
</script>

<style scoped>

</style>
